module.exports = __webpack_public_path__ + "static/media/sofaMain.7b61488a.png";